import {APP} from '../globals';
import {SpineLoader, Queue} from './loaders';
import SpineSprite from '../display/SpineSprite';

var ATLAS_SCALE = null;

/**
 * @class
 * @classdesc Библиотека анимаций Spine
 * @memberof module:media
 */
class SpineLibrary {

    /**
     * @param path путь к корневой папке конфигов
     * @param {Array} [list]
     */
    constructor(path = 'assets/spine', list = []) {

        this.path = path;
        this.items = new Map();
        this.loaded = false;

        this.textureAutoSufix = true;

        this.addItems(list);
    }

    addItems(list=[]) {
        for(let name of list) {
            this.items.set(name, {
                name: name,
                data: null
            });
        }
    }

    /**
     * Создаёт очередь загрузки для {@link module:media.module:queue.Loader Loader}
     * @return {module:media.module:queue.Queue}
     */
    createLoaderQueue(list) {

        this.addItems(list);

        let queue = new Queue();
        for (let [name] of this.items) {
            let ldr = new SpineLoader(this.path + "/" + name);
            ldr._spineName = name;
            queue.add(ldr);
        }

        queue.on('fileload', this.prepareSpineData, this);

        return queue;
    }

    detectAtlasScale() {
        if(ATLAS_SCALE) return ATLAS_SCALE;

        var max = -1;

        for(let scale of APP.config.scales) {
            if(scale > max) max = scale;
        }

        return max;
    }

    prepareSpineData(e) {
        let scale = APP.layout.bitmapScale;
        let texScale = -1;

        let atlas = e.item.data.atlas;
        let config = e.item.data.config;
        let name = e.item._spineName;

        let texturesList = [];

        let spineAtlas = new PIXI.spine.core.TextureAtlas(atlas, (line, callback) => {

            let parts = line.split(".");
            parts.pop();
            let assetName = parts.join(".");

            if(this.textureAutoSufix) {
                parts = name.split("/");
                if(parts.length > 1) {
                    parts.pop();
                    assetName = parts.join("/") + "/" + assetName;
                }
            }

            let tex = APP.library.getAsset(assetName).texture.baseTexture;

            if(texScale < 0) {
                texScale = this.detectAtlasScale(atlas, tex);
            }

            tex.resolution = texScale;
            texturesList.push(tex);

            callback(tex);
        });

        for(let tex of texturesList) tex.resolution = scale;

        let spineJsonParser = new PIXI.spine.core.SkeletonJson(new PIXI.spine.core.AtlasAttachmentLoader(spineAtlas));
        let skeletonData = spineJsonParser.readSkeletonData(config);

        this.items.set(name, {
            name: name,
            data: skeletonData
        });
    }

    /**
     * Возвращает конфиг Spine по имени
     * @param {String} name
     */
    getData(name) {
        let item = this.items.get(name);
        if(!item) throw Error("Spine data " + name + " not found");

        return item.data;
    }

    /**
     * Возвращает готовый спрайт по имени
     * @param {String} name
     * @returns {SpineSprite}
     */
    getSprite(name) {
        return new SpineSprite(this.getData(name));
    }

    /**
     * Масштаб атласов
     * @returns {number}
     */
    static get atlasScale() {
        return ATLAS_SCALE;
    }

    static set atlasScale(val) {
        ATLAS_SCALE = val;
    }
}

export default SpineLibrary;